<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title v-if="lista_setor" text="Links e Informações" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="showModalFormLink()"
      />
      <Lynx-Button
        text="Tipos Link"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="tipoLink()"
      />
      <Lynx-Button
        text="Atualizar planilha"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="listar_links()"
      />

      <Lynx-Button
        text="Gerar relatório"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="exportRelatorio('link-relatorio')"
      />
    </div>

    <div class="w-full flex justify-start gap-2 mb-2">
      <div class="grid grid-cols-4 gap-4">
        <label class="">
          <Lynx-Label label="Estados" />
          <Treeselect
            :options="lista_estados"
            placeholder="Selecione o estado"
            v-model="filtros.estado_id"
          />
        </label>
        <AutoCompleteCidade
          :cidades="lista_cidades"
          @filtrarCidades="filtroCidades"
        />
        <label class="pb-4">
          <Lynx-Label label="Local" />

          <Lynx-Input v-model="filtros.local" placeholder="Digite o local" />
        </label>
        <label class="pb-4">
          <Lynx-Label label="Descrição" />
          <Treeselect
            multiple
            :options="lista_descricao_tipo_link"
            placeholder="Selecione a descrição"
            v-model="filtros.descricao"
          />
        </label>
      </div>
    </div>
    <div class="flex justify-between">
      <label class="w-1/3 pb-4">
        <Lynx-Label label="Tipo link" />
        <Treeselect
          multiple
          :options="lista_tipos_link"
          placeholder="Selecione o tipo de link"
          v-model="filtros.tipo"
        />
      </label>

      <label class="">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>
    </div>
    <div cols="12" md="12" lg="12" class="table-container">
      <b-table
        :loading="loading"
        backend-pagination
         class="table"
        @page-change="onPageChange"
     
        :columns="columns"
        :data="loading ? [] : lista_links"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        paginated
        striped
        
        style="font-size: 13px;width:100vw;"
      >
        <template slot-scope="props" v-if="props.row.id != null">
          <b-table-column field="tipo_link.nome">
            <span v-if="props.row.tipo_link">{{
              props.row.tipo_link.nome
            }}</span>
          </b-table-column>

          <!-- <b-table-column field="descricao">
            {{ descricaoLabel(props.row.descricao) }}
          </b-table-column> -->

          <b-table-column field="estado.nome">
            <span v-if="props.row.estado">{{ props.row.estado.nome }}</span>
          </b-table-column>

          <b-table-column  field="cidade.nome">
            <span v-if="props.row.cidade">{{ props.row.cidade.nome }}</span>
          </b-table-column>

          <b-table-column field="telefone">
            {{ props.row.telefone }}
          </b-table-column>

          <b-table-column field="email">
            {{ props.row.email }}
          </b-table-column>
          <b-table-column field="local">
            {{ props.row.local }}
          </b-table-column>
          <b-table-column field="updated_at">
            {{ props.row.updated_at | formatEnToBr }}
          </b-table-column>
          <b-table-column style="width:200px" field="acoes">
            <div class="row gap-1">
            <v-btn
              x-small
              color="#051b3e"
              dark
              fab
              @click.native="enterCompetencia(props.row)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn
            x-small
              color="#051b3e"
              dark
              fab
              @click.native="atualizar(props.row)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
            v-if="hasRole('super-admin')"
            x-small
              color="error"
              dark
              fab
              @click.native="confirmDelete(props.row)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>

           
            <Logs :logs="props.row.activities" :comBotao="true"/>

          </div>
          </b-table-column>
        </template>
        <template v-slot:empty>
          <NotFoundData text="Nenhum convite encontrado!" />
        </template>
      </b-table>
    </div>
    <b-modal :active.sync="modalLink" :width="'100%'">
      <div class="bg-white p-5">
        <Lynx-Title text="Links" />

        <div class="grid grid-cols-2 gap-4">
          <label class="">
            <Lynx-Label label="Estados" />

            <Treeselect
              :options="lista_estados_form"
              placeholder="Selecione o estado"
              v-model="form.estado_id"
            />
          </label>
          <label class="">
            <Lynx-Label label="Cidades" />
            <Treeselect
              :options="lista_cidades_form"
              placeholder="Selecione a cidade"
              v-model="form.cidade_id"
            />
          </label>
          <label class="pb-4">
            <Lynx-Label label="Local" />

            <Lynx-Input v-model="form.local" placeholder="Digite o local" />
          </label>
          <label class="pb-4">
            <Lynx-Label label="telefone" />
            <Lynx-Input
              v-model="form.telefone"
              placeholder="Digite o telefone"
              :mask="['+55 (##) #####-####']"
            />
          </label>
        </div>
        <div class="grid-cols-1">
          <label class="flex flex-col w-full pb-4">
            <Lynx-Label label="Observação" />
            <Textarea
              v-model="form.observacao"
              placeholder="Digite a observação"
            />
          </label>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <label class="pb-4">
            <Lynx-Label label="Tipo link" />
            <Treeselect
              :options="lista_tipos_link"
              placeholder="Selecione o tipo de link"
              v-model="form.tipo_link_id"
            />
          </label>
          <label class="pb-4">
            <Lynx-Label label="Descrição" />
            <Treeselect
              :options="lista_descricao_tipo_link"
              placeholder="Selecione a descrição"
              v-model="form.descricao"
            />
          </label>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <label class="pb-4">
            <Lynx-Label label="Email" />
            <Lynx-Input v-model="form.email" placeholder="Digite o email" />
          </label>
        </div>

        <Lynx-Button
          class="my-4"
          size="small"
          icon="Plus"
          icon-size="4"
          @click.native="addInput()"
        />
        <div class="grid grid-cols-2 w-full gap-2">
          <div class="flex" v-for="(link, index) in links" :key="index">
            <label class="pb-4 w-full">
              <Lynx-Label label="Link" />
              <Lynx-Input v-model="link.value" placeholder="Digite o link" />
            </label>
            <div style="margin-top: 30px">
              <Lynx-Button
                size="x-small"
                icon="Trash"
                type="button"
                color="error-base"
                icon-size="4"
                @click.native="removeInput(index)"
              />
            </div>
          </div>
        </div>
      </div>
      <footer class="modal-card-foot flex justify-between">
        <b-button
          @click.native="hideModalFormLinks()"
          type="is-danger"
          class="mt-4"
          >Cancelar</b-button
        >
        <b-button
          @click.native="confirm(lista_campos == null ? 'cria' : 'edita')"
          type="is-primary"
          class="ml-4 mt-4"
          >Salvar</b-button
        >
      </footer>
    </b-modal>

    <b-modal :active.sync="modelLinks" :width="700">
      <div class="bg-white p-5">
        <Lynx-Title text="Links" />
        <div class="grid-cols-1 pb-4">
          <label class="flex flex-col w-full pb-4">
            <Lynx-Label label="Observação" />
            <Textarea
              disabled
              v-model="observacao"
              placeholder="Digite a observação"
            />
          </label>
          <label class="flex flex-col w-full pb-4">
            <Lynx-Label label="Descrição" />
            <Treeselect
              disabled
              :options="lista_descricao_tipo_link"
              placeholder="Selecione a descrição"
              v-model="descricao"
            />
          </label>
        </div>
        <div class="grid grid-cols-2 w-full gap-2">
          <div class="flex" v-for="(link, index) in links" :key="index">
            <label class="pb-4 w-full">
              <Lynx-Label label="Link" />
              <Lynx-Input
                disabled
                v-model="link.value"
                placeholder="Digite o link"
              />
            </label>
            <div style="margin-top: 30px">
              <Lynx-Button
                size="x-small"
                icon="Copy"
                type="button"
                color="success-base"
                icon-size="4"
                @click.native="copyText(link.value)"
              />
            </div>
          </div>
        </div>
      </div>
      <footer class="modal-card-foot flex justify-between">
        <b-button @click.native="modalLinks()" type="is-danger" class="mt-4"
          >fechar</b-button
        >
      </footer>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";

import Textarea from "@/components/helpers/Textarea";
import { monthNames } from "@/utils/utils";
import moment from "moment";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import {
  indexEstadosRequest,
  showEstadosRequest,
} from "@/services/requests/estados";

import listaDescricaoTipoLink from "@/utils/enums/descricaoTipoLink";
import AutoCompleteCidade from "@/views/components/AutoCompleteCidade.vue";
import Logs from "@/views/empresas/alvaras/Logs.vue"

export default {
  components: {
    NotFoundData,
    Treeselect,
    Textarea,
    AutoCompleteCidade,
    Logs,
  },
  data() {
    return {
      lista_descricao_tipo_link: listaDescricaoTipoLink,

      monthNames,
      form: {
        observacao: "",
        estado_id: null,
        cidade_id: null,
        local: "",
        telefone: "",
        descricao: null,
        tipo_link_id: null,
        links: null,
      },


      lista_campos: [],
      links: [{ value: "" }],
      columns: [
        {
          field: "tipo_link.nome",
          label: "Tipo",
        },

        {
          field: "estado.nome",
          label: "estado",
        },
        {
          field: "cidade.nome",
          label: "cidade",
        },

        {
          field: "telefone",
          label: "Telefone",
        },
        {
          field: "email",
          label: "Email",
        },
        {
          field: "local",
          label: "Local",
        },

        {
          field: "updated_at",
          label: "Atualização",
        },

        {
          field: "acoes",
          label: "Ações",
        },
      ],
      filtros: {
        perPage: 10,
        cidade_id: null,
        estado_id: null,
        local: null,
        descricao: null,
        tipo: null,
      },
      observacao: "",
      descricao: "",
      modalLink: false,
      loading: false,
      loadingInicial: false,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      empresas_id: null,
      modelLinks: false,
      estados: [],
      cidades: [],
      perPageOptions: [10, 50, 100],
      current_page: 1,
      lista_setor: [],
      formulario: false,
      uf: null,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    getlinks() {
      return this.$store.state.link.lista_link;
    },

    lista_links() {
      return this.getlinks.data;
    },

    pagination() {
      return this.getlinks.pagination;
    },
    mensagem_alert() {
      return this.$store.state.link.mensagem_alert;
    },
    lista_tipos_link() {
      return this.$store.state.tipoLink.lista_tipos_link_todos.map((tipo) => {
        return {
          id: tipo.id,
          label: tipo.nome,
        };
      });
    },

    lista_cidades() {
      return this.generateSelectOptions(this.cidades, true, true);
    },
    lista_estados() {
      return this.generateSelectOptions(this.estados, true);
    },
    lista_cidades_form() {
      return this.generateSelectOptions(this.cidades, false);
    },
    lista_estados_form() {
      return this.generateSelectOptions(this.estados, false);
    },
  },
  watch: {
    "filtros.perPage"() {
      this.listar_links();
    },
    sub_setor: function (value) {
      this.listar_links();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_links();
    },
    "form.estado_id": function () {
      if (this.form.estado_id != null) {
        this.onSelectEstado(this.form.estado_id);
      }
    },
    "filtros.estado_id": function () {
      if (this.filtros.estado_id != null) {
        this.onSelectEstado(this.filtros.estado_id);
      }
    },
  },
  created() {
    this.listar_inicial();
  },
  mounted() {
    this.listar_tipos_link();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,
    async confirm(tipo) {
      this.form.links = JSON.stringify(this.links);

      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` uns links no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },
    create() {
      this.loading = true;
      // this.form.links = this.links;

      let podeFechar = false;
      this.$store
        .dispatch("link/create_link", this.form)
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
            podeFechar = true;
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          if (podeFechar) {
            this.listar_links();
            this.hideModalFormLinks();
          }

          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      // this.form.links = this.links;

      let podeFechar = false;
      this.$store
        .dispatch("link/update_link", this.form)
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
            podeFechar = true;
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          if (podeFechar) {
            this.listar_links();
            this.hideModalFormLinks();
          }

          this.loading = false;
        });
    },
    async listar_inicial() {
      this.loadingInicial = true;
      await this.listar_links();
      await this.fetchEstados();
      this.loadingInicial = false;
    },
    enterCompetencia(link) {
      this.observacao = link.observacao;
      this.descricao = link.descricao;
      this.links = JSON.parse(link.links);
      this.modalLinks();
    },
    modalLinks() {
      this.modelLinks = !this.modelLinks;
    },
    hideModalFormLinks() {
      this.modalLink = false;
    },
    showModalFormLinkUpdate() {
      this.modalLink = true;
    },
    showModalFormLink() {
      this.lista_campos = null;
      this.form = {
        observacao: "",
        estado_id: null,
        cidade_id: null,
        local: "",
        telefone: "",
        descricao: null,
        tipo_link_id: null,
        links: null,
      };
      this.links = [{ value: "" }];
      this.modalLink = true;
    },
    async listar_links() {
      this.loading = true;
      if (this.filtros.local == "") {
        this.filtros.local = null;
      }

      const { filtros } = this;
      await this.$store.dispatch("link/listar_links", filtros);
      this.loading = false;
    },
    async listar_tipos_link() {
      await this.$store.dispatch("tipoLink/listar_tipos_link_todas");
    },
    tipoLink() {
      this.$router.push({
        name: "tipos-link.index",
      });
    },
    onPageChange(page) {
      this.current_page = page;
    },
    async confirmDelete(link) {
      await this.$buefy.dialog.confirm({
        message: "Esta ação deleta uma atividade no sistema?",
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          this.delete(link);
        },
      });
    },
    async delete(link) {
      await this.$store
        .dispatch("link/delete_link", link)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    generateSelectOptions(data, formulario, cidade = false) {
      let options = [];
      if (formulario) {
        options.push({ id: 0, label: "Todos" });
      }
      for (let i = 0; i < data.length; i++) {
        if (cidade) {
          options.push({ id: data[i].id, label: data[i].nome + "-" + this.uf });
        } else {
          options.push({ id: data[i].id, label: data[i].nome });
        }
      }
      return options;
    },
    fetchEstados() {
      this.loadingInicial = true;
      indexEstadosRequest()
        .then((res) => (this.estados = res.data))
        .finally(() => (this.loadingInicial = false));
    },
    async onSelectEstado(id) {
      this.loadingInicial = true;
      await showEstadosRequest(id)
        .then((res) => {
          this.cidades = res.data.cidades;
          this.uf = res.data.uf;
        })
        .finally(() => (this.loadingInicial = false));
    },
    atualizar(value) {
      this.lista_campos = value;

      this.form = {
        id: value.id,
        observacao: value.observacao,
        descricao: value.descricao,
        estado_id: value.estado_id,
        cidade_id: value.cidade_id,
        telefone: value.telefone,
        email: value.email,
        local: value.local,
        tipo_link_id: value.tipo_link_id,
        links: JSON.parse(value.links),
      };
      this.links = JSON.parse(value.links);

      this.showModalFormLinkUpdate();
    },
    addInput() {
      this.links.push({ value: "" });
    },
    removeInput(index) {
      this.links.splice(index, 1);
    },
    copyText(value) {
      this.$snack.success("Copiado com sucesso");

      this.$copyText(value);
    },
    descricaoLabel(descricaoId) {
      const item = this.lista_descricao_tipo_link.find(
        (item) => item.id == descricaoId
      );
      return item ? item.label : "Não encontrado";
    },

    exportRelatorio(nome) {
      const { filtros } = this;

      // Utility function to serialize the filtros object to a query string
      const serialize = (obj) => {
        return Object.keys(obj)
          .filter((key) => obj[key] !== null && obj[key] !== undefined) // Filter out null or undefined values
          .map((key) => {
            // Check if the value is an array
            if (Array.isArray(obj[key])) {
              // Serialize array elements individually
              return obj[key]
                .map(
                  (item) =>
                    `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`
                )
                .join("&");
            } else {
              // Serialize non-array values
              return `${encodeURIComponent(key)}=${encodeURIComponent(
                obj[key]
              )}`;
            }
          })
          .join("&");
      };

      const queryString = serialize(filtros);

      const url = `${process.env.VUE_APP_API_URL}/${nome}?token=${this.$store.getters.getToken}&${queryString}`;
      window.open(url, "_blank");
    },
    filtroCidades(cidades) {
      this.filtros.cidade_id = cidades;
    },
  },
};
</script>

<style scoped>
</style>
  